export enum DocumentVisibility {
  Intern = 'affinis_documentvisibility-100000000',
  InternAndContractors = 'affinis_documentvisibility-100000001',
  Public = 'affinis_documentvisibility-100000002',
}

export enum DocumentType {
  Bestandsplan = 'BSP',
  AmtlicheUnterlagenGrundstück = 'AUG',
  Pläne = 'PL7',
  Schriftverkehr = 'SVK',
  Sonstiges = 'SO7',
}
